import { EditorContext, WithEditorActions } from '@atlaskit/editor-core';
import { token } from '@atlaskit/tokens';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { FunctionComponent, useState } from 'react';
import { Renderer } from '../components/Renderer';
import { SandboxEditor } from '../components/SandboxEditor';
import { DocumentStorageProvider } from '../providers/document-storage';
import { EditorActionsProvider } from '../providers/actions-provider';
import { SignupAndSaveButtons } from 'src/components/SignupButtons';
import {
  SandboxActionsProvider,
  useSandboxActions
} from '../providers/sandbox-actions';
import { isVersion } from '../utils/version';

const HomePageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  max-height: 100%;
  overflow: auto;
`;

const bannerHeader = css`
  font-size: 15px;
  line-height: 24px;
  font-weight: 600;
  color: ${token('color.text')};
`;

const bannerText = css`
  font-size: 15px;
  line-height: 24px;
  color: ${token('color.text')};
  margin-left: 4px;
  padding-right: 20px;
`;

const banner = css`
  background-color: #deebff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
`;

const WelcomeBanner = () => {
  const { signup } = useSandboxActions();
  return (
    <div css={banner}>
      <span css={bannerHeader}>{'Welcome to the Confluence editor.'}</span>
      <span css={bannerText}>
        {isVersion(2)
          ? 'To save pages and get the full editor experience, sign up for Confluence.'
          : 'To save and share pages, sign up for Confluence.'}
      </span>
      <SignupAndSaveButtons key={1} signup={() => signup(false)} />
    </div>
  );
};

const HomePage: FunctionComponent = () => {
  const [isEditingMode, setEditingMode] = useState(true);

  return (
    <DocumentStorageProvider
      loadFromStorage={false}
      loadFromQuery={isVersion(2)}
    >
      <SandboxActionsProvider>
        <WelcomeBanner />
        <HomePageContainer>
          <EditorContext>
            {isEditingMode ? (
              <WithEditorActions
                render={(actions) => (
                  <EditorActionsProvider actions={actions}>
                    <SandboxEditor setMode={setEditingMode} />
                  </EditorActionsProvider>
                )}
              />
            ) : (
              <Renderer setMode={setEditingMode} />
            )}
          </EditorContext>
        </HomePageContainer>
      </SandboxActionsProvider>
    </DocumentStorageProvider>
  );
};

export default HomePage;
